<template>
  <base-form :can-back="canBack">
    <slot />
    <template #submit-button>
      <register-button class="px-5" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import RegisterButton from '@/views/molecules/buttons/RegisterButton'

export default {
  name: "RegisterForm",
  components: {
    BaseForm,
    RegisterButton,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
